import { commify } from '../commify';

const CURRENCY_SYMBOLS = {
  en: '$',
  jp: '¥',
  kr: '원',
} as const;

const isNumericString = (value: string): boolean => /^-?\d*\.?\d*$/.test(value.trim()) && value !== '';

export const formatCurrency = (price: string | number, lang: keyof typeof CURRENCY_SYMBOLS): string => {
  const symbol = CURRENCY_SYMBOLS[lang];
  const defaultValue = lang === 'en' ? '0.00' : '0';

  if (!isNumericString(String(price))) {
    return `${lang === 'kr' ? defaultValue + symbol : symbol + defaultValue}`;
  }

  const value = lang === 'en' ? commify(parseFloat(String(price)).toFixed(2)) : commify(price);

  return lang === 'kr' ? `${value}${symbol}` : `${symbol}${value}`;
};
